/**
 * Site footer — edit freely.
 */
const NHTSA_REPORT =
  "https://crashstats.nhtsa.dot.gov/Api/Public/ViewPublication/813403";

export const footerContent = {
  citation: `[National Highway Traffic Safety Administration. The Economic and Societal Impact of Motor Vehicle Crashes, 2019 (Revised).](${NHTSA_REPORT})`,

  caveats: [
    "Maryland police injury codes are mapped approximately to NHTSA MAIS-based unit costs.",
    "Unit costs are averages; individual crashes can differ greatly.",
    "Comprehensive costs include QALY-valued losses, not only direct economic costs.",
    "Property-damage-only crashes use per-vehicle costs only; injury crashes do not add a separate PDO line.",
  ],

  attribution:
    "Basemap © OpenStreetMap contributors via OpenFreeMap. Census boundaries © U.S. Census Bureau.",
};
